(function (window, $, app) {
    app.$doc = $(window.document);
    app.$body = $('body');
    app.ANIMATION_DURATION = 300;
    
    app.bind();
    app.ActionResolver.bindActions();
})(window, jQuery, MedwaySchools);
